function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Provider } from './SardineContext';
var getSardineHost = function getSardineHost(environment, region) {
  var isSandbox = environment === 'sandbox';
  var regionValue = region === 'default' ? '' : region || '';
  regionValue = regionValue ? "".concat(regionValue, ".") : '';
  return isSandbox ? "api.sandbox.".concat(regionValue, "sardine.ai") : "api.".concat(regionValue, "sardine.ai");
};
var SardineProvider = function SardineProvider(props) {
  var children = props.children,
    clientId = props.clientId,
    environment = props.environment,
    region = props.region,
    apiSubdomain = props.apiSubdomain,
    pixelSubdomain = props.pixelSubdomain,
    onSuccess = props.onSuccess;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    sardineContextObj = _useState2[0],
    setSardineContextObj = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    setupConfig = _useState4[0],
    setSetupConfig = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    deviceResponse = _useState6[0],
    setDeviceResponse = _useState6[1];
  var activeSessionKey = "";
  var sardineHost = getSardineHost(environment, region);
  var parentDomain = apiSubdomain || sardineHost;
  useEffect(function () {
    var _s$parentNode;
    if (!setupConfig || !(setupConfig !== null && setupConfig !== void 0 && setupConfig.sessionKey) || sardineContextObj) {
      return function () {};
    }
    var customerId = setupConfig.customerId,
      sessionKey = setupConfig.sessionKey,
      flow = setupConfig.flow,
      enableBiometrics = setupConfig.enableBiometrics,
      enableGeoLocation = setupConfig.enableGeoLocation,
      enablePortScanning = setupConfig.enablePortScanning,
      fields = setupConfig.fields,
      parentSessionKey = setupConfig.parentSessionKey,
      partnerId = setupConfig.partnerId;
    var script = document.createElement('script');
    script.src = "https://".concat(parentDomain, "/assets/loader.min.js");
    script.async = true;
    script.type = 'text/javascript';
    script.onload = function () {
      var _window;
      /*
       * Creating context as per the docs and will expose it in future
       * https://docs.sardine.ai/web
       */
      var context = (_window = window) === null || _window === void 0 || (_window = _window._Sardine) === null || _window === void 0 ? void 0 : _window.createContext({
        clientId: clientId,
        sessionKey: sessionKey,
        userIdHash: customerId,
        flow: flow || window.location.pathname,
        environment: environment,
        partnerId: partnerId,
        parentSessionKey: parentSessionKey,
        enablePortScanning: enablePortScanning,
        enableBiometrics: enableBiometrics || true,
        enableGeoLocation: enableGeoLocation,
        apiSubdomain: apiSubdomain,
        pixelSubdomain: pixelSubdomain,
        fields: fields,
        parentElement: document.body,
        onDeviceResponse: function onDeviceResponse(data) {
          setDeviceResponse(data);
          onSuccess && onSuccess(data);
        }
      });
      setSardineContextObj(context);
    };
    var s = document.getElementsByTagName('script')[0];
    s === null || s === void 0 || (_s$parentNode = s.parentNode) === null || _s$parentNode === void 0 || _s$parentNode.insertBefore(script, s);
    return function () {
      script.remove();
    };
  }, [setupConfig]);
  return _jsx(Provider, {
    value: {
      updateSardineConfig: function updateSardineConfig(config) {
        if (sardineContextObj) {
          var updateStatus = sardineContextObj.updateConfig(config);
          if (!updateStatus) {
            return false;
          }
        }
        setSetupConfig(config);
        activeSessionKey = config.sessionKey || "";
        return true;
      },
      getSardineSessionKey: function getSardineSessionKey() {
        return activeSessionKey;
      },
      logoutUserOnSardine: function logoutUserOnSardine() {
        if (sardineContextObj) {
          return sardineContextObj.updateConfig({
            customerId: undefined
          });
        }
        return false;
      },
      unbind: function unbind() {
        if (sardineContextObj) {
          sardineContextObj.unbind();
          return true;
        }
        return false;
      },
      getDeviceResponse: function getDeviceResponse() {
        return deviceResponse;
      },
      bind: function bind() {
        if (sardineContextObj) {
          sardineContextObj.bind();
          return true;
        }
        return false;
      }
    },
    children: children
  });
};
export { SardineProvider, getSardineHost };